import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { Subject } from 'rxjs';
import { InmueblesService } from '../inmuebles.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  inmuebles: any[] = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(public inmu: InmueblesService, public rest: RestService) { }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }

    };
    this.getInmuebles();
  }

  getLocation() {
    const destroy = new Promise(
      (resolve, reject) => {
        this.dtTrigger.unsubscribe();
        resolve();
      }
    );
    // Client REST Api
    this.rest.getGeolocation(15000, '', '', '', 'precio', '')
      .subscribe(
        (data) => {
          destroy.then((then) => {
            this.inmuebles = data['data'];
            this.dtTrigger.next();
          });
        });
  }

  getInmuebles() {
    const start = new Promise(
      (resolve, reject) => {
        this.inmuebles = this.inmu.inmuebles;
        resolve();
      }
    );
    start.then((data) => {
      this.dtTrigger.next();
    });

  }

}
